import { render, staticRenderFns } from "./PrevNextBar.vue?vue&type=template&id=47179f30&scoped=true&"
import script from "./PrevNextBar.vue?vue&type=script&lang=js&"
export * from "./PrevNextBar.vue?vue&type=script&lang=js&"
import style0 from "./PrevNextBar.vue?vue&type=style&index=0&id=47179f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47179f30",
  null
  
)

export default component.exports